// @flow

import { resolve, reject } from 'redux-optimist-promise';

export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCH_CUSTOMER_RESOLVED = resolve(FETCH_CUSTOMER);
export const FETCH_CUSTOMER_REJECTED = reject(FETCH_CUSTOMER);
